<script setup>
import showSideBarStore from '@src/application/store/show-side-bar-store';
import mobileDetectStore from '@src/application/store/mobile-detect-store';
import Link from '@components/link.vue';
import Icon from '@components/icons/icon.vue';

function hideSideBar() {
    showSideBarStore.showSideBar.data = false;
}
</script>

<template>
    <div :class="[$style.sidebar__controller, mobileDetectStore.isMobile.data ? $style.mobile : '']">
        <Link :class="$style.home" href="/">
            <img :class="$style.logo" src="@assets/bb-logo/bb-logo.svg" alt="logo"/>
        </Link>
        <label :class="$style.close" @click="hideSideBar">
            <Icon icon="times" icon-color="white"/>
        </label>
    </div>
</template>

<style lang="scss" module>
@use '@backgrounds' as *;

.sidebar__controller {
    display: flex;
    gap: 1em;
    background-color: $sidebar-background;

    .close {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2.5rem;
        height: 2.5rem;
        color: #fff;
        cursor: pointer;

        &:hover {
            color: #fff;
            background-color: $sidebar-background-hover;
        }
    }
    .home {
        display: flex;
        flex-grow: 1;
        align-items: center;
        margin-left: 1.3em;

        .logo {
            max-width: 100%;
        }
    }
    &.mobile {
        position: sticky;
        top: 0;

        .logo {
            max-height: 1.2em;
        }
    }
}
</style>
